import { useState } from "react";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errorMessage } from "@/lib/api";

const inp = "bg-[#0B0F19] border border-[#26334D] rounded-xl px-3 py-2 text-sm outline-none focus:border-[#00E5A3] [color-scheme:dark]";
export const AUDIENCES = [["all", "Everyone"], ["user", "Travelers only"], ["vendor", "Businesses only"]];

export function PromoCreateForm({ onCreated }) {
  const [f, setF] = useState({ code: "", max_uses: 10, expires: "", audience: "all" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: k === "code" ? e.target.value.toUpperCase().replace(/[^A-Z0-9-]/g, "") : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/admin/promos", { ...f, max_uses: Number(f.max_uses) });
      toast.success(`Code ${f.code} created`);
      setF({ code: "", max_uses: 10, expires: "", audience: "all" });
      onCreated();
    } catch (err) { toast.error(errorMessage(err)); }
    finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} data-testid="promo-create-form" className="grid sm:grid-cols-2 gap-3 rounded-2xl bg-[#0B0F19]/60 border border-[#26334D] p-4">
      <label className="text-xs text-slate-400 space-y-1">Code word (3–20 letters/numbers)
        <input data-testid="promo-new-code" required minLength={3} maxLength={20} value={f.code} onChange={set("code")} placeholder="SUMMER25" className={`${inp} w-full font-mono-vv tracking-wider`} />
      </label>
      <label className="text-xs text-slate-400 space-y-1">Number of uses
        <input data-testid="promo-new-uses" type="number" required min={1} max={100000} value={f.max_uses} onChange={set("max_uses")} className={`${inp} w-full`} />
      </label>
      <label className="text-xs text-slate-400 space-y-1">Expires (leave empty for never)
        <input data-testid="promo-new-expires" type="date" min={new Date().toLocaleDateString("en-CA")} value={f.expires} onChange={set("expires")} className={`${inp} w-full`} />
      </label>
      <label className="text-xs text-slate-400 space-y-1">Who can use it
        <select data-testid="promo-new-audience" value={f.audience} onChange={set("audience")} className={`${inp} w-full`}>
          {AUDIENCES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
      </label>
      <Button data-testid="promo-create-button" type="submit" disabled={busy || f.code.length < 3}
        className="sm:col-span-2 rounded-full bg-[#00E5A3] hover:bg-[#00C98F] text-[#0B0F19] font-semibold">
        <Plus className="h-4 w-4 mr-1.5" /> {busy ? "Creating…" : "Create promo code"}
      </Button>
    </form>
  );
}
